module.exports = __webpack_public_path__ + "static/media/Profile Pic.729f549f.JPG";